import { all, call, put, takeLatest } from 'redux-saga/effects'
import { ApiClient } from '../../../utilities/api';
import { onErrorStopLoad, setGetAllUsers, setTrafficData } from '../../slices/dashboard';
import ApiPath from '../../../constants/apiPath';
import { toast } from 'react-toastify';
import { setGetspotLightData, setactiveUserList, setcompanyList, setspotLightData } from '../../slices/spotlight';


function* getspotLightData(action) {
    try {
        const resp = yield call(ApiClient.post, action.url = ApiPath.SpotLightApiPath.CREATE_SPOTLIGHT, action.payload = action.payload);
        if (resp.status) {
            yield put(setGetspotLightData(resp.data.payload));
            yield call(action.payload.cb, action.res = resp)
            toast.success(action?.res?.data?.msg);
        }
        else {
            throw resp
        }
    } catch (e) {
        yield put(setGetspotLightData({}));
        yield put(onErrorStopLoad())
        toast.error(e.response.data.msg);
    }
}

function* spotLightData(action) {
    try {
        const resp = yield call(ApiClient.get, action.url = ApiPath.SpotLightApiPath.CREATE_SPOTLIGHT, action.payload = action.payload);
        if (resp.status) {
            yield put(setspotLightData(resp.data.payload));
            yield call(action.payload.cb, action.res = resp)
            // toast.success(action?.res?.data?.msg);
        }
        else {
            throw resp
        }
    } catch (e) {
        yield put(setspotLightData({}));
        yield put(onErrorStopLoad())
        toast.error(e.response.data.msg);
    }
}

function* companyList(action) {
    try {
        const resp = yield call(ApiClient.get, action.url = ApiPath.SpotLightApiPath.COMPANY_LIST, action.payload = action.payload);
        if (resp.status) {
            yield put(setcompanyList(resp.data.payload));
            yield call(action.payload.cb, action.res = resp)
            // toast.success(action?.res?.data?.msg);
        }
        else {
            throw resp
        }
    } catch (e) {
        yield put(setcompanyList({}));
        yield put(onErrorStopLoad())
        toast.error(e.response.data.msg);
    }
}

function* activeUserList(action) {
    var dataToSend = { ...action.payload }
    delete dataToSend.cb
    try {
        const resp = yield call(ApiClient.get, action.url = ApiPath.SpotLightApiPath.ACTIVE_USERS, action.params = { params: dataToSend });
        if (resp.status) {
            yield put(setactiveUserList(resp.data.payload));
            yield call(action.payload.cb, action.res = resp)
            // toast.success(action?.res?.data?.msg);
        }
        else {
            throw resp
        }
    } catch (e) {
        yield put(setactiveUserList({}));
        yield put(onErrorStopLoad())
        toast.error(e.response.data.msg);
    }
}

function* spotlightSaga() {
    yield all([
        takeLatest('spotlight/getspotLightData', getspotLightData),
        takeLatest('spotlight/spotLightData', spotLightData),
        takeLatest('spotlight/companyList', companyList),
        takeLatest('spotlight/activeUserList', activeUserList),
    ])
}

export default spotlightSaga;